/* unplugin-vue-components disabled */import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["fill", "xlink:href"];
export default {
  __name: 'index',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const iconName = computed(() => `#icon-${props.iconClass}`);
    const svgClass = computed(() => {
      if (props.className) {
        return `svg-icon ${props.className}`;
      }
      return "svg-icon";
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(_unref(svgClass)),
        "aria-hidden": "true"
      }, [_createElementVNode("use", {
        fill: __props.color,
        "xlink:href": _unref(iconName)
      }, null, 8, _hoisted_1)], 2);
    };
  }
};